<template>
  <div class="content">
    <base-header :choose-index="-1"></base-header>
    <div class="middle_content">
      <div class="middle_content-banner" v-bgImg="require('@@/assets/img/westa/join/加入我们配图.png')"></div>
      <div class="middle_content-type">
        <div
          class="middle_content-type-item"
          :class="{'middle_content-type-item-active': chooseTab === '招聘职位'}"
          @click="chooseTab = '招聘职位'"
        >招聘职位</div>
        <div
          class="middle_content-type-item"
          :class="{'middle_content-type-item-active': chooseTab === '公司福利'}"
          @click="chooseTab = '公司福利'"
        >公司福利</div>
        <div
          class="middle_content-type-item"
          :class="{'middle_content-type-item-active': chooseTab === '公司架构'}"
          @click="chooseTab = '公司架构'"
        >公司架构</div>
        <div
          class="middle_content-type-item"
          :class="{'middle_content-type-item-active': chooseTab === '员工风采'}"
          @click="chooseTab = '员工风采'"
        >员工风采</div>
      </div>
      <!-- 招聘职位 -->
      <div v-show="chooseTab === '招聘职位'">
        <div class="middle_content-down">
          <el-input class="middle_content-down-input1" v-model="key_word" placeholder="请输入职位关键词"></el-input>
          <el-button class="middle_content-down-btn" @click="getInfo(1)" type="primary">搜索</el-button>
        </div>
        <div class="middle_content-down1">
          <el-select
            class="middle_content-down1-select"
            v-model="job_name"
            placeholder="招聘岗位"
            clearable
          >
            <el-option v-for="(item, index) in job_names" :key="index" :label="item" :value="item"></el-option>
          </el-select>
          <el-select
            class="middle_content-down1-select1"
            v-model="job_location"
            placeholder="工作地点"
            clearable
          >
            <el-option
              v-for="(item, index) in job_locations"
              :key="index"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </div>
        <div class="middle_content-list">
          <div
            class="middle_content-list-item"
            v-for="item in website_jobs"
            :key="item.job_id"
            @click="showDetails(item)"
          >
            <div class="middle_content-list-item-up">
              <div>{{item.job_name}}</div>
              <div class="middle_content-list-item-up-price">{{item.job_price}}</div>
            </div>
            <div class="middle_content-list-item-down">
              <div>地点：{{item.job_location}} 招聘人数：{{item.job_num}}人</div>
              <div>{{timestampTo(item.job_post_time)}} 发布</div>
            </div>
          </div>
        </div>
        <div class="news_pagination">
          <el-pagination
            layout="prev, pager, next"
            background
            @current-change="getInfo"
            :current-page.sycn="page"
            :total="total"
          ></el-pagination>
        </div>
      </div>

      <!-- 公司福利 -->
      <div v-show="chooseTab === '公司福利'">
        <div class="fuli">
          <div class="fuli-item" v-for="(item, index) in content_joinus_gsfla" :key="index">
            <div class="fuli-item-title">{{item.title}}</div>
            <div class="fuli-item-content">{{item.content}}</div>
          </div>
        </div>
      </div>

      <!-- 公司架构 -->
      <div v-show="chooseTab === '公司架构'">
        <div class="jiagou" v-for="(item, index) in content_joinus_gsjg" :key="index">
          <img :src="utils.getQiniuWidthUrl(item.gsjg_imgs, 1200, 1, 'webp')" />
        </div>
      </div>

      <!-- 员工风采 -->
      <div v-show="chooseTab === '员工风采'">
        <div class="jiagou" v-for="(item, index) in content_joinus_ygfc" :key="index">
          <img :src="utils.getQiniuWidthUrl(item.ygfc_imgs, 1200, 1, 'webp')" />
        </div>
      </div>
    </div>
    <base-footer></base-footer>

    <el-dialog :visible.sync="centerDialogVisible" width="1000px" center>
      <div class="dialog">
        <div class="dialog-p1">发布时间：{{timestampTo(job_detail.job_post_time)}}</div>
        <div class="dialog-p2">{{job_detail.job_name}}</div>
        <div class="dialog-p3">
          <div class="dialog-p3-p1">薪资：</div>
          <div class="dialog-p3-p2">{{job_detail.job_price}}</div>
          <div class="dialog-p3-p3">地点：{{job_detail.job_location}}</div>
          <div class="dialog-p3-p3">招聘人数：{{job_detail.job_num}}人</div>
        </div>
        <div class="dialog-p3">
          <div>职位描述</div>
          <div class="dialog-p3-p4"></div>
        </div>
        <div class="dialog-p4">{{job_detail.job_duty}}</div>
        <div class="dialog-p3">
          <div>任职资格</div>
          <div class="dialog-p3-p4"></div>
        </div>
        <div class="dialog-p4">{{job_detail.job_qualification}}</div>
        <div class="dialog-p5"></div>
        <a href="mailto:hr@changdi.com.cn">
          <div class="dialog-p6" v-bgImg="require('@@/assets/img/westa/join/申请职位拷贝.png')"></div>
        </a>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import BaseHeader from "@@/components/westa/base-header";
import BaseFooter from "@@/components/westa/base-footer";
export default {
  data() {
    return {
      chooseTab: "招聘职位",
      page: 1,
      page_count: 10,
      total: 0,
      key_word: "",
      job_names: [],
      job_name: "",
      job_locations: [],
      job_location: "",
      website_jobs: [],
      centerDialogVisible: false,
      job_detail: {},
      content_joinus_gsfla: [],
      content_joinus_gsjg: [],
      content_joinus_ygfc: []
    };
  },
  components: {
    BaseHeader,
    BaseFooter
  },
  watch: {
    $route(to, from) {
      // 对路由变化作出响应...
      let tag = this.$route.query.tag;
      this.chooseTab = tag;
      this.getInfo(1);
      this.getContent();
    }
  },
  created() {
    let tag = this.$route.query.tag;
    this.chooseTab = tag;
    this.getInfo(1);
    this.getContent();
  },
  mounted() {},
  methods: {
    getInfo(page) {
      if (page != null) {
        this.page = page;
      }
      let params = {
        key_word: this.key_word,
        job_name: this.job_name,
        job_location: this.job_location,
        page: this.page - 1,
        page_count: this.page_count
      };
      this.req
        .get(url_api_web_websiteJob_getWebsiteJobs, this.qs.stringify(params))
        .then(result => {
          this.job_names = result.job_names;
          this.job_locations = result.job_locations;
          this.website_jobs = result.website_jobs;
          this.total = result.total;

          console.log(typeof this.total);
        })
        .catch(error => {});
    },
    getContent() {
      let params = {};
      this.req
        .get(
          url_api_web_websiteContent_getWebsiteContent,
          this.qs.stringify(params)
        )
        .then(result => {
          this.content_joinus_gsfla = JSON.parse(
            result.website_content.content_joinus_gsfla
          );
          this.content_joinus_gsjg = JSON.parse(
            result.website_content.content_joinus_gsjg
          );
          this.content_joinus_ygfc = JSON.parse(
            result.website_content.content_joinus_ygfc
          );
        })
        .catch(error => {});
    },
    timestampTo(timestamp) {
      let date = new Date(timestamp * 1000);
      let Y = date.getFullYear();
      let M =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      let D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      let strtime = Y + "-" + M + "-" + D;
      return strtime;

      // 格式为：2019/02/19 下午2:32:33
      // let str = date.toLocaleString()
      // return str
    },
    showDetails(obj) {
      this.job_detail = obj;
      this.centerDialogVisible = true;
    }
  }
};
</script>


<style lang="less" scoped>
.middle_content {
  padding-top: 64px;
  background: #f4f4f4;
  min-width: 1200px;
  padding-bottom: 80px;
  &-banner {
    width: 100%;
    height: 300px;
  }
  &-type {
    width: 100%;
    height: 80px;
    background: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    // font-family: "SourceHanSansCN-Medium";
    font-size: 24px;
    color: #666;
    &-item {
      width: 155px;
      text-align: center;
      height: 80px;
      line-height: 80px;
      margin: 0 26px;
      cursor: pointer;

      &-active {
        color: #181f99;
        border-bottom: 5px solid #181f99;
      }
    }
  }
  &-down {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    margin-top: 48px;
    &-input1 {
      width: 610px;
    }
    &-btn {
      width: 80px;
      height: 40px;
      margin-left: 24px;
    }
  }
  &-down1 {
    width: 1200px;
    margin: 20px auto;
    display: flex;
    &-select {
      width: 330px;
      margin-right: 24px;
    }
    &-select1 {
      width: 360px;
    }
  }
  &-list {
    width: 1200px;
    margin: 0 auto;
    &-item {
      width: 100%;
      height: 98px;
      background: #fff;
      margin-bottom: 20px;
      cursor: pointer;
      &-up {
        display: flex;
        justify-content: space-between;
        padding: 20px 30px;
        padding-bottom: 10px;
        box-sizing: border-box;
        font-size: 20px;
        &-price {
          color: #181f99;
        }
      }
      &-down {
        display: flex;
        justify-content: space-between;
        padding: 0 30px;
        box-sizing: border-box;
        font-size: 16px;
        color: #999;
      }
    }
  }
}
.news_pagination {
  display: flex;
  justify-content: flex-end;
  width: 1200px;
  margin: 0 auto;
  padding: 20px 0;
}
.dialog {
  padding: 36px 56px;
  box-sizing: border-box;
  color: #000;
  &-p1 {
    font-size: 12px;
    color: #999;
    margin-bottom: 16px;
  }
  &-p2 {
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 24px;
  }
  &-p3 {
    display: flex;
    align-items: center;
    font-size: 16px;
    color: #000;
    margin-bottom: 30px;
    &-p1 {
      color: #666;
    }
    &-p2 {
      font-weight: bold;
    }
    &-p3 {
      color: #666;
      margin-left: 36px;
    }
    &-p4 {
      width: 750px;
      height: 1px;
      margin-left: 10px;
      background: #ebebeb;
    }
  }
  &-p4 {
    font-size: 16px;
    color: #666;
    margin-bottom: 36px;
    white-space: pre-wrap;
    word-wrap: break-word;
    word-break: break-all;
  }
  &-p5 {
    width: 100%;
    height: 1px;
    background: #ebebeb;
    margin-bottom: 30px;
  }
  &-p6 {
    width: 100px;
    height: 36px;
    margin: 0 auto;
  }
}
.fuli {
  width: 1200px;
  margin: 0 auto;
  padding: 36px 56px;
  box-sizing: border-box;
  background: #fff;
  margin-top: 36px;
  &-item {
    &-title {
      font-size: 24px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    &-content {
      font-size: 16px;
      color: #666;
      white-space: pre-wrap;
      word-wrap: break-word;
      word-break: break-all;
      margin-bottom: 36px;
      line-height: 26px;
    }
  }
}
.jiagou {
  width: 1200px;
  margin: 0 auto;
  margin-top: 36px;
}
</style>

